import { DayShortName } from '../shared/schedule.entity';

export enum WorkDefaultTime {
    MorningAfternoon = 'Morning/Afternoon',
    SpecificTime = 'SpecificTime'
}

export interface ScheduleSetting {
    dayStartTime?: string;
    dayEndTime?: string;
    workDefaultTime?: WorkDefaultTime;
    workWeek?: DayShortName[];
    useSchedulingEnabled?: boolean;
}
